export const API_URL = 'https://api1.api-kujilab.com'